<template>
  <v-dialog v-model="dialog"
            persistent
            max-width="500px"
            @keydown.esc="closeDialog('')"
  >
    <v-card>
      <div class="add_fa" style="height: 280px;">
        <button class="close_bt" @click="closeDialog('')"></button>
        <span class="s_pop_title" style="margin-bottom: 20px;">녹화 안내 문구 작성</span>
        <div style="height: 10px;"></div>
        <input 
            solo
            placeholder="녹화 안내 문구를 작성해 주세요"
            v-model="contents"
            v-on:keyup.enter="createMeetingBookmark()">
        <div class="danger-alert" v-if="error">
          {{error}}
        </div>            
        <div class="btnArea">
          <button type="submit" class="btn type3" @click="createRecLog">저장</button>
          <button type="submit" class="btn type3 reset" @click="close()">취소</button>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import Util from '@/util';

export default {
  components: {
  },
  props: [
    'dialog',
    'recContents',
    'closeDialog'
  ],
  data () {
    return {
      loading: true,
      error: null,
      contents: null,
    };
  },
  watch: {
    dialog: {
      handler (val) {
        this.loading = false;
        this.error = null;
        this.init();
      }
    }
  },
  methods: {
    init () {
      console.log(this.recContents);
      this.error = null;
      this.contents = this.recContents;
    },
    close () {
      this.init();
      this.closeDialog('');
    },
    async createRecLog () {
      this.closeDialog(this.contents);
    }
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/popup/RecLogDialog.vue